import { defineComponent as _defineComponent } from 'vue'
import ApplyGiftCardModal from 'JS/components/payment/ApplyGiftCardModal.vue';
import ConfirmRemovalModal from 'JS/components/payment/ConfirmRemovalModal.vue';
import Icon from 'JS/components/Icon.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import ReviewBlock from './ReviewBlock.vue';
import ReviewDetail from './ReviewDetail.vue';
import SelectedPayment from 'JS/components/payment/SelectedPayment.vue';
import SelectedPaymentDisplay from 'JS/components/payment/SelectedPaymentDisplay.vue';
import WorkOrderSubmitButton from '../../work-order/WorkOrderSubmitButton.vue';
import { AutomotiveSchedulerStep, ISelectedService, IWorkOrderCustomerInfoResource, IWorkOrderPaymentInfoResource, IWorkOrderServiceInfoResource, WorkOrderAppointmentInfo, WorkOrderAppointmentInfoState, WorkOrderTotalType, WorkOrderType } from 'JS/automotive/auto-service-scheduler/types/session';
import { computed, reactive, ref } from 'vue';
import { DEFAULT_GLOBAL_ERROR_MESSAGE } from 'JS/constants/errors';
import { getAppointmentDateString, getAppointmentIcon, getAppointmentStartDate, getAppointmentTitleString, getAppointmentTypeString } from 'JS/automotive/auto-service-scheduler/utils/helpers';
import { getSelectedServices } from 'JS/automotive/auto-service-scheduler/utils/helpers';
import { ICheckoutPayment } from 'JS/types/Checkout';
import { IconName } from 'JS/constants/icons';
import { useApplyGiftCardModal } from 'JS/automotive/auto-service-scheduler/composables/apply-gift-card';
import { useBreakpoints } from 'JS/composables/breakpoint';
import { useOrderStore } from '../../../state/order';
import { useServices } from 'JS/automotive/auto-service-scheduler/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewStep',
  setup(__props) {

const orderStore = useOrderStore();
const orderType = computed<WorkOrderType>(() => orderStore.session.type);

const contactInfo = computed<IWorkOrderCustomerInfoResource>(() => orderStore.session?.customerInfo);

const paymentInfo = computed<IWorkOrderPaymentInfoResource>(() => orderStore.session?.paymentInfo);

const serviceInfo = computed<IWorkOrderServiceInfoResource>(() => orderStore.session?.serviceInfo);
const selectedServices: ISelectedService[] = getSelectedServices(serviceInfo.value);
const { paymentService, logService } = useServices();

const appointmentInfo = computed<WorkOrderAppointmentInfo>(() => orderStore.session?.appointmentInfo);

const appointmentDuration = computed(() => appointmentInfo.value.estimatedAppointmentDurationLabel);
const startDate = computed<Date>(() => getAppointmentStartDate(appointmentInfo.value));
const appointmentDate = computed(() => getAppointmentDateString(startDate.value, appointmentInfo.value.state == WorkOrderAppointmentInfoState.TimeSlot));
const appointmentType = computed(() => getAppointmentTypeString(appointmentInfo.value));
const appointmentIcon = computed<IconName>(() => getAppointmentIcon(orderType.value));
const appointmentTitle = computed(() => getAppointmentTitleString(orderType.value));

const cardToRemove = ref<ICheckoutPayment | null>(null);
const removingPaymentMethod = ref(false);
const orderedCheckoutPayments = computed(() => {
	const payments = paymentInfo.value;
	return payments.paymentMethods.sort((a, b) => a.amount < b.amount ? -1 : 1);
});

async function removeCard() {
	try {
		removingPaymentMethod.value = true;
		const session = await paymentService.removePaymentMethod(cardToRemove.value.paymentMethodID);
		orderStore.setSession(session);
	} catch (e) {
		logService.log(e);
		orderStore.setGlobalErrorMessage(DEFAULT_GLOBAL_ERROR_MESSAGE);
	}

	cardToRemove.value = null;
	removingPaymentMethod.value = false;
}

function handleUpdateCard(card: ICheckoutPayment) {
	cardToRemove.value = card;
}

const applyGiftCardModal = reactive(useApplyGiftCardModal(false));

const { isDesktop } = useBreakpoints();

return { __sfc: true,orderStore, orderType, contactInfo, paymentInfo, serviceInfo, selectedServices, paymentService, logService, appointmentInfo, appointmentDuration, startDate, appointmentDate, appointmentType, appointmentIcon, appointmentTitle, cardToRemove, removingPaymentMethod, orderedCheckoutPayments, removeCard, handleUpdateCard, applyGiftCardModal, isDesktop, ApplyGiftCardModal, ConfirmRemovalModal, Icon, LinkButton, ReviewBlock, ReviewDetail, SelectedPayment, SelectedPaymentDisplay, WorkOrderSubmitButton, AutomotiveSchedulerStep, WorkOrderTotalType, WorkOrderType }
}

})